// extracted by mini-css-extract-plugin
module.exports = {"flex":"homepageNav_flex__3v7WS","box":"homepageNav_box__x2GKF"};